import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner'

/**
 * Feedback de sucesso: aviso discreto em ink no canto inferior, com "desfazer" por 10 segundos
 * quando a ação permite — sem modal para confirmar o óbvio. Fato, não celebração:
 * "3 documentos a caminho de Amanda." · "Cadastro salvo." Sem exclamação.
 * Erro de ação não vai em toast: usa `ActionError`, que fica na tela até ser resolvido.
 */

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-center"
      gap={8}
      offset={28}
      toastOptions={{
        unstyled: true,
        duration: 4000,
        classNames: {
          toast:
            'flex items-center gap-5 bg-ink px-5 py-[14px] font-body text-[13px] leading-none font-light text-pampas shadow-float',
          title: 'font-light',
          actionButton:
            'ml-auto cursor-pointer border-b border-pampas/40 pb-px font-body text-[12px] leading-none font-light text-pampas hover:border-pampas',
        },
      }}
    />
  )
}

export interface ToastOptions {
  /** Ação de desfazer, mantida por 10 segundos. */
  undo?: () => void
  undoLabel?: string
  duration?: number
}

/** `toast('3 documentos a caminho de Amanda.', { undo })` */
export function toast(message: string, options: ToastOptions = {}) {
  const { undo, undoLabel = 'Desfazer', duration } = options
  return sonnerToast(message, {
    duration: duration ?? (undo ? 10_000 : 4000),
    action: undo ? { label: undoLabel, onClick: undo } : undefined,
  })
}

toast.dismiss = sonnerToast.dismiss
